import { SystemSettingMap } from "./systemSettingAction";

const initialState = {
  isLoading: false,
  systemSettingData: {},
  refreshSystemSettingdata: true,
  selectedSystemSetting: null,
  search: "",
  templates: [],
  searchText: "",
  skip: 0,
  limit: 10,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SystemSettingMap.GET_ALL_SYSTEM_SETTING_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SystemSettingMap.GET_ALL_SYSTEM_SETTING_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        systemSettingData: action.payload,
        refreshSystemSettingdata: false,
      };
    }
    case SystemSettingMap.GET_ALL_SYSTEM_SETTING_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshSystemSettingdata: false,
      };
    }

    case SystemSettingMap.UPDATE_SYSTEM_SETTING_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SystemSettingMap.UPDATE_SYSTEM_SETTING_SUCCESS: {
      return {
        ...state,
        refreshSystemSettingdata: true,
      };
    }
    case SystemSettingMap.UPDATE_SYSTEM_SETTING_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshSystemSettingdata: false,
      };
    }
    case SystemSettingMap.GET_ALL_TEMPLATES_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SystemSettingMap.GET_ALL_TEMPLATES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        templates: action.payload,
        refreshSystemSettingdata: true,
      };
    }
    case SystemSettingMap.GET_ALL_TEMPLATES_ERROR: {
      return {
        ...state,
        isLoading: false,
        templates: [],
        refreshSystemSettingdata: false,
      };
    }
    case SystemSettingMap.SELECT_SYSTEM_SETTING_DETAILS: {
      return {
        ...state,
        isLoading: false,
        selectedSystemSetting: action.payload,
      };
    }
    case SystemSettingMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case SystemSettingMap.SET_SYSTEM_SETTING_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshSystemSettingdata: true,
      };
    }
    case SystemSettingMap.REFRESH_SYSTEM_SETTING_LIST: {
      return {
        ...state,
        skip: 0,
        refreshSystemSettingdata: true,
      };
    }
    default:
      return { ...state };
  }
};
